module.exports = __webpack_public_path__ + "img/1F1F5-1F1FC.fbba6f5a.svg";